import { styled } from "@mui/styles";
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { Chip, Paper, Typography } from "@mui/material";

export const StyledPaper = styled(Paper)(({ theme })=>({
    display: 'flex',
    borderRadius: '5px',
    marginBottom: 10,
    '& .MuiBox-root a img': {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        borderRadius: '5px 0 0 5px',
        maxWidth: '300px'
    },
    '& .MuiCard-root': {
        width: '100%', boxShadow: 'none'
    },
    '& .MuiCardContent-root': {
        position: 'relative'
    },
    [theme.breakpoints.down('sm')]:{
        display: 'contents',
        '& .MuiBox-root a img': {
            maxWidth: '100%',
            borderRadius: '5px'
        },
    }
}));

export const BoldTitle = styled(Typography)({
    fontWeight: '600 !important', 
    color:"black"
});

export const Badge = styled(Chip)({
    paddingLeft: 5,
    paddingRight: 5,
    marginRight: 5
});

const useStyles = makeStyles(() =>
    createStyles({
        editIcon: {
            position: 'absolute !important', 
            top: 0, 
            right: 0
        }
    }),
);

export default useStyles;